import { orchestrator } from "satcheljs";
import { getBrowserWidth } from "owa-config";
import { onCopilotChatDrawerOpened, onCopilotChatDrawerCollapsedState, onCopilotChatDrawerExpandedState, COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT, shouldChatCollapseFolderPane, getShowBizChatInReadingPane, } from "owa-copilot-chat-drawer-store";
import { type StateChangeSource } from "owa-left-pane-layout/lib/types/StateChangeSource";
import { getLastCollapsedFolderPaneStateChangeSource, getLastExpandedFolderPaneStateChangeSource, } from "owa-left-pane-layout/lib/utils/folderPaneStateTracking";
import { setShowFolderPane } from "../actions/setShowFolderPane";
import { shouldShowFolderPane } from "../selectors/shouldShowFolderPane";

/**
 * Orchestrator for when Copilot Chat Drawer is opening. Used for any side effects for that state.
 *
 * Currently, main side effect is that folder pane should collapse when chat is opening. This is
 * beneath a flight, and is an experiment to give more space to the user when Chat is opened.
 *
 * We skip collapsing the folder pane when:
 * - The action originated from a popout window (folder pane only exists in the main window)
 * - Chat is shown in the reading pane (search scenario) since it already has its own space
 */
orchestrator(onCopilotChatDrawerOpened, actionMessage => {
    const { targetWindow } = actionMessage;
    if (targetWindow === window && // only affect main window
        getBrowserWidth() < COLLAPSE_FOLDER_PANE_WHEN_CHAT_OPENED_BREAKPOINT &&
        shouldShowFolderPane() && // if FP is shown
        !getShowBizChatInReadingPane(targetWindow) // don't collapse FP if chat is in reading pane
    ) {
        setShowFolderPane(false /* showFolderPane */, 9);
    }
});

/**
 * Orchestrator for when Copilot Chat Drawer is collapsed to minimum width.
 *
 * Used here as a signal to determine whether we should reshow folder pane for the user.
 * We only reshow if the last time folder pane collapsed was due to chat opening.
 */
orchestrator(onCopilotChatDrawerCollapsedState, actionMessage => {
    const { targetWindow } = actionMessage;
    if (targetWindow === window && // only affect main window
        getLastCollapsedFolderPaneStateChangeSource() === 9 &&
        !shouldShowFolderPane() // if FP is currently hidden
    ) {
        setShowFolderPane(true /* showFolderPane */, 10);
    }
});

/**
 * Orchestrator for when Copilot Chat Drawer is expanded from minimum width.
 *
 * Used here as a signal to determine whether we should re-hide folder pane for the user.
 * We only re-hide if the last time folder pane expanded was due to chat being in collapsed state.
 */
orchestrator(onCopilotChatDrawerExpandedState, actionMessage => {
    const { targetWindow } = actionMessage;
    if (targetWindow === window && // only affect main window
        getLastExpandedFolderPaneStateChangeSource() === 10 &&
        shouldShowFolderPane() && // if FP is currently shown
        shouldChatCollapseFolderPane()) {
        setShowFolderPane(false /* showFolderPane */, 9);
    }
});
